module.exports = __webpack_public_path__ + "static/media/paper_covid_tests_getty_desktop.4311caf5.jpg";